var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/setting-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "setting-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.5 10C9.60457 10 10.5 9.10457 10.5 8C10.5 6.89543 9.60457 6 8.5 6C7.39543 6 6.5 6.89543 6.5 8C6.5 9.10457 7.39543 10 8.5 10Z",
    stroke: "#123EC9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.83203 8.58679V7.41345C1.83203 6.72012 2.3987 6.14679 3.0987 6.14679C4.30536 6.14679 4.7987 5.29345 4.19203 4.24679C3.84536 3.64679 4.05203 2.86679 4.6587 2.52012L5.81203 1.86012C6.3387 1.54679 7.0187 1.73345 7.33203 2.26012L7.40536 2.38679C8.00536 3.43345 8.99203 3.43345 9.5987 2.38679L9.67203 2.26012C9.98536 1.73345 10.6654 1.54679 11.192 1.86012L12.3454 2.52012C12.952 2.86679 13.1587 3.64679 12.812 4.24679C12.2054 5.29345 12.6987 6.14679 13.9054 6.14679C14.5987 6.14679 15.172 6.71345 15.172 7.41345V8.58679C15.172 9.28012 14.6054 9.85345 13.9054 9.85345C12.6987 9.85345 12.2054 10.7068 12.812 11.7535C13.1587 12.3601 12.952 13.1335 12.3454 13.4801L11.192 14.1401C10.6654 14.4535 9.98536 14.2668 9.67203 13.7401L9.5987 13.6135C8.9987 12.5668 8.01203 12.5668 7.40536 13.6135L7.33203 13.7401C7.0187 14.2668 6.3387 14.4535 5.81203 14.1401L4.6587 13.4801C4.05203 13.1335 3.84536 12.3535 4.19203 11.7535C4.7987 10.7068 4.30536 9.85345 3.0987 9.85345C2.3987 9.85345 1.83203 9.28012 1.83203 8.58679Z",
    stroke: "#123EC9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.ca4298fdf94182d3aa626f7fbe5cf36c.svg";
export { ForwardRef as ReactComponent };